import { IconConfig } from "../types";

export const UserCircleCheck: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 34 34",
  elements: [
    {
      type: 'g',
      id: "icon-user-check",
      fill: "#fff",
      children: [
        {
          type: 'path',
          id: "path-user-circle-check-1",
          d: "M22.419 23.828a.746.746 0 0 1-.746-.746v-1.493a2.24 2.24 0 0 0-2.239-2.239h-5.225a2.24 2.24 0 0 0-2.239 2.239v1.493a.747.747 0 0 1-1.493 0v-1.493a3.73 3.73 0 0 1 3.732-3.731h5.224a3.736 3.736 0 0 1 3.731 3.731v1.493a.746.746 0 0 1-.745.746"
        },
        {
          type: 'path',
          id: "path-user-circle-check-2",
          d: "M16.821 8.903a3.731 3.731 0 1 1-3.731 3.731 3.736 3.736 0 0 1 3.731-3.731m0 5.97a2.239 2.239 0 1 0-2.238-2.239 2.24 2.24 0 0 0 2.238 2.239"
        },
        {
          type: 'path',
          id: "path-user-circle-check-3",
          d: "M24.658 17.859a.74.74 0 0 1-.528-.219l-1.493-1.493a.746.746 0 1 1 1.055-1.055l.965.965 2.462-2.457a.746.746 0 0 1 1.055 1.055l-2.985 2.985a.74.74 0 0 1-.531.219"
        }
      ]
    }
  ]
} as const
